import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import {
  formatChange,
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValue,
} from '../../../../helpers/Text';

class Tooltip extends PureComponent {
  render() {
    const {
      data,
      secondTitle,
      thirdTitle,
      secondValue,
      thirdValue,
      textClassName,
    } = this.props;

    return (
      <>
        <div className="matched">
          <Translate value="moneyFlowCommon.tooltipMatched" />
          <strong>{`${formatTextFloat(formatPrice(data.matchPrice))} `}</strong>
          (
          <span className={`${textClassName} text-bold`}>
            {`${formatChange(formatTextFloat(formatPrice(data.priceChange)))} `}
          </span>
          /
          <span className={`${textClassName} text-bold`}>
            {` ${formatTextFloat(formatPercent(data.percentPriceChange))}`} %
          </span>
          )
        </div>
        <div className="value">
          <Translate value={secondTitle} />
          <strong>{formatTextFloat(formatValue(secondValue))}</strong>
        </div>
        {thirdValue && (
          <div className="net">
            <Translate value={thirdTitle} />
            <strong>{thirdValue}</strong>
          </div>
        )}
      </>
    );
  }
}

Tooltip.propTypes = {
  data: PropTypes.object.isRequired,
  secondTitle: PropTypes.string.isRequired,
  secondValue: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  thirdTitle: PropTypes.string,
  thirdValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Tooltip;
